export const ORDER_BY = {
  ASC: 'ASC',
  DESC: 'DESC',
};
